import React, { useState, useEffect } from "react";
import DashboardLayout from "../../molecules/DashboardLayout";
import { Row, Col, Pagination, Card, Button, Form, Space, Select, Input, Tag } from "antd";
import SectionHeader from "../../molecules/SectionHeader";
import Grid from "../../atoms/Grid";
import { useDispatch, useSelector } from "react-redux";
import { emptyManagers, getManagers, getMasterManagers } from "./ducks/actions";
import { EditOutlined, SearchOutlined } from "@ant-design/icons";
import Title from "antd/es/typography/Title";
import { Popup } from "../../atoms/Popup";
import AddManager from "./AddManager";
import { formatString } from "../../../utils/formatString";

const gridProps = {
  sortable: true,
  filter: true,
  resizable: true,
  minWidth: 200,
};

const limit = 20;

const searchBy = [{ label: "Manager Name", value: "name" }];

export default (props) => {
  const dispatch: any = useDispatch();
  const id = location.pathname?.split("/")[2];
  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const managerApi = useSelector((state: any) => state.managers.managersList);
  const [searchBy, setSearchBy] = useState(null);
  const [visible, setVisible] = useState(false);
  const [trigger, setTrigger] = useState(0);
  const [selected, setSelected] = useState();
  const [updates, setUpates] = useState(false);

  function viewRender(record) {
    return <Button icon={<EditOutlined />} onClick={() => onEdit(record.data)} type="link" className="ag-primary" />;
  }

  const getManagerStatus = (status) => {
    switch (status) {
      case "enable":
        return "Active";
        break;
      case "disable":
        return "In Active";
        break;

      default:
        break;
    }
  };

  const managerCol = [
    {
      headerName: "User Name",
      field: "name",
    },
    {
      headerName: "Mobile Number",
      field: "mobile",
    },
    {
      headerName: "Email",
      field: "email",
      // width: 400
    },
    {
      headerName: "Manager",
      field: "managerName",
      // width: 400
    },
    {
      headerName: "Buildings",
      field: "properties",
      width: 500,
      cellRenderer: (record) => {
        return (
          <>
            {record?.data?.properties?.map((tag) => {
              return (
                <Tag key={tag.propertyName} className="tag-sm">
                  {tag.propertyName}
                </Tag>
              );
            })}
          </>
        );
      },
    },
    {
      headerName: "Can View",
      field: "canView",
      cellRenderer: (record) => (record?.data?.canView ? formatString(record?.data?.canView) : "--"),
    },
    {
      headerName: "Status",
      field: "status",
      cellRenderer: (record) => (record?.data?.status ? getManagerStatus(record?.data?.status) : "--"),
      maxWidth: 140,
    },
    {
      headerName: "View Details",
      cellRenderer: viewRender,
      cellStyle: { textAlign: "center" },
      filter: false,
      maxWidth: 140,
    },
  ];

  const addNew = () => {
    setVisible(true);
    setTrigger(0);
  };

  const onEdit = (record) => {
    setVisible(true);
    setTrigger(1);
    setSelected(record);
  };

  const onAdd = () => {
    setVisible(false);
    dispatch(getManagers(id, limit, currentPage, "", ""));
    dispatch(getMasterManagers());
  };

  const popup = [
    {
      title: (
        <Title level={3} className="m-0">
          Add New User
        </Title>
      ),
      content: (
        <>
          <AddManager
            onSubmit={onAdd}
            onCancel={() => setVisible(false)}
            onUpdate={setUpates}
            onchangeUpdate={updates}
            editMode={false}
          />
        </>
      ),
      width: 950,
    },
    {
      title: (
        <Title level={3} className="m-0">
          Edit User
        </Title>
      ),
      content: (
        <>
          <AddManager
            data={selected}
            onSubmit={onAdd}
            onCancel={() => setVisible(false)}
            onUpdate={setUpates}
            onchangeUpdate={updates}
            editMode={true}
          />
        </>
      ),
      width: 950,
    },
  ];

  const popupProps = {
    closable: true,
    visibility: visible,
    title: popup[trigger].title,
    content: popup[trigger].content,
    width: popup[trigger].width,
    onCancel: () => setVisible(false),
  };

  //@ts-ignore
  useEffect(() => {
    dispatch(getManagers(id, limit, currentPage, searchBy, ""));
    return () => dispatch(emptyManagers());
  }, [searchBy]);

  const handlePagination = (pg) => {
    setCurrentPage(pg);
    dispatch(getManagers(id, limit, pg, "", ""));
  };

  const onSearch = (val) => {
    setCurrentPage(1);
    if (val) {
      setSearchBy(val);
    } else {
      setSearchBy("");
    }
  };

  useEffect(() => {
    if (managerApi?.data) {
      let temp = [];
      managerApi?.data?.map((item) => {
        temp.push({
          name: item.name,
          mobile: item.mobile,
          usertype: item.usertype,
          properties: item.properties,
          userId: item.userId,
          status: item.status,
          visiblity: item.visiblity,
          managerId: item.managerId,
          email: item.email,
          screens: item?.accessibleScreens,
          canDeactivateRestore: item?.canDeactivateRestore,
          managerName: item?.managerName,
          canView: item?.visiblity,
          canChequeCleared: item?.canChequeCleared,
          canApproveReceipts: item?.canApproveReceipts,
        });
      });
      setData(temp);
    }
  }, [managerApi]);

  return (
    <>
      <DashboardLayout>
        <Row gutter={[32, 32]}>
          <Col span={24}>
            <Row gutter={[24, 24]}>
              <Col span={24}>
                <SectionHeader
                  heading="Users"
                  noBorder={true}
                  total={managerApi?.totalCount}
                  addNewAction={addNew}
                  search={(e) => onSearch(e)}
                  searchLabel="Search by user name"
                />
              </Col>

              <Col span={24} className="managers_tenants_detail">
                <Card bordered={false} className="ag-nospace-body">
                  <Grid
                    data={data}
                    columns={managerCol}
                    pagination={false}
                    defaultSettings={gridProps}
                    noRowlabel="Managers"
                    fullPage={true}
                  />
                </Card>
              </Col>
              <Col span={24}>
                <Pagination
                  className="ag-property-text-pagination"
                  total={managerApi?.totalCount || 0}
                  showTotal={(total, range) => `Showing ${range[0]}-${range[1]} of ${total} Users`}
                  pageSize={managerApi?.perPage || 20}
                  defaultCurrent={1}
                  showSizeChanger={false}
                  current={currentPage}
                  onChange={(e) => handlePagination(e)}
                />
              </Col>
            </Row>
          </Col>
        </Row>
      </DashboardLayout>
      <Popup {...popupProps} />
    </>
  );
};
